import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import { PersistGate } from 'redux-persist/integration/react';

import configureStore from './stores/configureStore';
import * as serviceWorker from './serviceWorker';

import App from './App';

import { TextFont } from '@agrostar/textfonts';

export const { store, persistor } = configureStore();

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <App />
      <TextFont />
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);
serviceWorker.unregister();
